import React from 'react';
import { Link } from 'react-router-dom';
import { SERVICES_LIST } from '../servicedata';

const ServiceGrid = () => {


  return (
    <section className="service pb-10 bg-white">
      <div className="container">
        <div className="service-inner">
          {/* Section Header */}
          <div className="section-title mb-6 text-center text-lg-start">
            <div className="row gx-lg-5 gy-4 align-items-center">
              <div className="col-lg-7">
                <div className="section-title-left">
                  <h6 className="mb-2 green text-uppercase fw-medium">Our Services</h6>
                  <h2 className="ps-4 border-start border-3 border-success fw-bold">
                    Best EV <span className="green">charging service</span> for your electric vehicle
                  </h2>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="section-title-right">
                  <p className="mb-3 text-muted">
                    Denial Enterprise provides turnkey infrastructure for MNCs, bridging the gap between high-voltage engineering and sustainable transport.
                  </p>
                  <Link to="/services" className="btn btn-success btn-sm px-4 rounded-pill">
                    More Services
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Service Cards */}
          <div className="section-body">
            <div className="row gy-4">
              {SERVICES_LIST.slice(0,6).map((service) => (
                <div key={service.id} className="col-lg-4 col-md-6">
                  <div className="service-box p-5 border bg-white border-2 border-light rounded-4 shadow-sm h-100 transition-hover">
                    <div className="service-icon mb-4">
                      <img 
                        src={service.icon} 
                        alt={service.title} 
                        style={{ width: '100px', height: '100px' }}
                      />
                    </div>
                    <div className="service-info">
                      <h4 className="fw-bold">
                        <Link to={service.path} className="text-dark text-decoration-none">
                          {service.title}
                        </Link>
                      </h4>
                      <p className="mt-2 mb-4 text-muted small">
                        {service.desc}
                      </p>
                      <Link 
                        to={service.path} 
                        className="btn btn-outline-success btn-sm px-4 rounded-pill"
                      >
                        Learn More
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceGrid;